import axios, { AxiosResponse } from 'axios'
import { GetOAuthTokenRequest, TokenResponse } from './generated/models'

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080'

const oauthClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

export const oauthApi = {
  getAccessToken: async (request: GetOAuthTokenRequest): Promise<TokenResponse> => {
    const response: AxiosResponse<TokenResponse> = await oauthClient.post('/api/v1/oauth/token', request)
    return response.data
  },
}
